import { CircularProgress, Grid, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { Params, useNavigate, useParams } from "react-router-dom";
import { useGetScenesQuery } from "../../services/scene.service";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { useGetMarksQuery } from "../../services/marks.service";
import { PieChart } from "@mui/x-charts";
import { VTButton, VTTypography, VTUserSelectTable } from "@virtus-tech-repository/virtus-tech-repository";
import { IScene } from "@virtus-tech-repository/virtus-tech-repository/lib/models/scenario.model";
import VTTimelineItem from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTimelineItem";
import { getImageForSceneOrDefaultImageIfPreviewImageDoesntExist } from "../../utils/getImageForSceneOrDefaultImageIfPreviewImageDoesntExist";
import { useGetScenarioOverviewQuery } from "../../services/scenario.service";
import { useGetScenarioAttemptsQuery, useGetUserAttemptsQuery } from "../../services/tracking.service";
import { UserAttemptRowObjectType } from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTableBasic";
import { setSelectedAttempt, setSelectedUser } from "../../store/slices/current.slice";

interface IProps {
    trackingItem: any;
    small?: boolean;
    setCorrectSceneList: any;
    correctSceneList: any;
}

export default function ViewMarksItem({ trackingItem, small = false, setCorrectSceneList, correctSceneList }: IProps) {
    const theme = useTheme();
    const { scenarioId }: Readonly<Params<string>> = useParams();

    const dispatch = useAppDispatch();
    const { data: scenes } = useGetScenesQuery(scenarioId ? scenarioId : "");
    const { currentSidePanel, selectedAttempt, selectedUser, currentSidePannelDesiredWidth } = useAppSelector(
        (state) => state.currentReducer,
    );

    const { id } = useAppSelector((state) => state.userReducer);
    const { data: scenarioOverviewData } = useGetScenarioOverviewQuery(scenarioId ? scenarioId : "");
    const [filteredAttemptData, setFilteredAttemptData] = useState<any[]>();
    const [filteredMarksData, setFilteredMarksData] = useState<any[]>();
    const { data: tracking } = useGetScenarioAttemptsQuery({ scenarioId: scenarioId });

    const { data: userAttempts } = useGetUserAttemptsQuery(
        trackingItem && trackingItem.id
            ? { scenarioId: scenarioId, userId: trackingItem.id }
            : { scenarioId: "", userId: "" },
    );
    const [currentAttempt, setCurrentAttempt] = useState<any>(undefined);
    const [currentScore, setCurrentScore] = useState<number>(0);
    const navigate = useNavigate();

    const markCorrectComparison = [
        "1dcdb062-eb0c-41a3-8c56-082f476e1c29",
        "3dc12da1-e579-40f7-8041-a9dc5d9dc6f9",
        "26183454-4381-46b4-b10c-64bb579896fa",
        "86519329-c2a4-4649-8e9c-5e70e5e66d51",
        "46caaf35-1e0f-43ad-897c-d368c6605a6e",
        "40901d4c-4b64-4ff8-bc33-0ccd9abe4579",
    ];
    const markIncorrectComparison = [
        "bcb9dfbd-c302-42f6-a9eb-67aed50533ba",
        "c04108b2-a1de-4add-83e2-0f776b2ee573",
        "f151c049-e048-46e0-a86f-20e7f6476335",
        "5fe57456-d662-42e6-8dee-5b62e0712b27",
        "8184fa1b-c9ea-4d97-924f-4c94921afeb5",
        "22a2bd68-0cd2-4731-9bda-0aaac60a2af8",
        "bccdab21-472b-48f6-8f80-7e571de24953",
        "c8f85ee7-3ae9-450b-ac62-c7d30955c999",
        "34bda1f6-55b6-4e0a-8717-a67d68b3e3d8",
        "649132cc-4416-473a-85cd-8b1c8236b716",
        "1bd2c7cc-f6a4-42e4-8c29-4a4438cf1a6a",
        "b0154a79-2f55-409a-88b5-d0ec6038c214",
        "0adb79c7-02fd-46cb-85ba-48ecf30d7286",
        "c3204a4b-48c3-4f61-ac6a-11883a68cbbc",
        "c0cefccd-1331-4e82-9fb5-502910fd2f3e",
        "3a5c9e1c-4645-4695-9a10-1a687aa0b5a2",
        "6c105f3d-d7fb-46ab-9539-5a70e78998b6",
    ];
    const {
        data: marksMapData,
        currentData: marksMapCurrentData,
        isLoading: isLoadingMarks,
        error: marksError,
        isFetching: isFetchingMarks,
    } = useGetMarksQuery(scenarioId!);

    useEffect(() => {
        if (userAttempts) {
            setCurrentAttempt(
                [...userAttempts].sort((a: any, b: any) => b.data.actions.length - a.data.actions.length)[0],
            );
        }
    }, [userAttempts]);

    useEffect(() => {
        console.log("length: ", currentAttempt);
    }, [currentAttempt]);

    useEffect(() => {
        // console.log("DGB : selectedAttempt", selectedAttempt);
        let tempArray: any[] = [];
        let tempCorrectSceneList: string[] = [];
        let userScore = 0;

        if (selectedAttempt && currentAttempt && selectedAttempt.userId === currentAttempt.userId) {
            selectedAttempt.data.actions.forEach((element: any) => {
                if (
                    element.sceneId === "c8077f90-da47-4168-91aa-c9233fed82d3" ||
                    element.sceneId === "19965592-557d-4de3-a475-e7673e040015" ||
                    element.sceneId === "7e80b2ac-0943-4480-b94b-5c019b2650f5" ||
                    element.sceneId === "b2f4b70b-6e8e-4a05-8798-d2c272b74eaa" ||
                    element.sceneId === "f096f3fc-5796-41f1-b8e2-ded339d7080c" ||
                    element.sceneId === "bd59080f-8c59-4eae-9139-72c08e7e6afa"
                ) {
                    let firstCorrect: boolean = true;
                    element.hotspotActions.forEach((subElement: any) => {
                        if (subElement.action === "Clicked" && firstCorrect) {
                            if (markCorrectComparison.includes(subElement.hotspotId)) {
                                userScore = userScore + 1;
                                tempCorrectSceneList.push(element.sceneId);
                                firstCorrect = false;
                            } else if (markIncorrectComparison.includes(subElement.hotspotId)) {
                                firstCorrect = false;
                            }
                        }
                    });
                }
            });
            setFilteredAttemptData(tempArray);
        } else if (currentAttempt) {
            currentAttempt.data.actions.forEach((element: any) => {
                if (
                    element.sceneId === "c8077f90-da47-4168-91aa-c9233fed82d3" ||
                    element.sceneId === "19965592-557d-4de3-a475-e7673e040015" ||
                    element.sceneId === "7e80b2ac-0943-4480-b94b-5c019b2650f5" ||
                    element.sceneId === "b2f4b70b-6e8e-4a05-8798-d2c272b74eaa" ||
                    element.sceneId === "f096f3fc-5796-41f1-b8e2-ded339d7080c" ||
                    element.sceneId === "bd59080f-8c59-4eae-9139-72c08e7e6afa"
                ) {
                    element.hotspotActions.forEach((subElement: any) => {
                        let firstCorrect = true;

                        if (subElement.action === "Clicked" && firstCorrect === true) {
                            if (markCorrectComparison.includes(subElement.hotspotId)) {
                                userScore = userScore + 1;
                                tempCorrectSceneList.push(element.sceneId);
                                firstCorrect = false;
                            } else if (markIncorrectComparison.includes(subElement.hotspotId)) {
                                firstCorrect = false;
                            }
                        }
                    });
                }
            });
            setFilteredAttemptData(tempArray);
        }

        setCurrentScore(userScore);
        setCorrectSceneList([
            ...correctSceneList,
            { id: trackingItem.id, user: trackingItem.email.split("@")[0], mark: `${userScore} / 6` },
        ]);
        // if (selectedUser && selectedUser.id === trackingItem.id) {
        //     setCorrectSceneList(tempCorrectSceneList);
        // }
    }, [currentAttempt, selectedAttempt]);

    // useEffect(() => {
    //     console.log("DGB : selectedUser", selectedUser);
    // }, [selectedUser]);

    // useEffect(() => {
    //     if (marksMapData) {
    //         let weightedArray: any[] = [];
    //         Object.keys(marksMapData).map(function (key) {
    //             if (Array.isArray(marksMapData[key].sceneHotspots)) {
    //                 //@ts-ignores
    //                 marksMapData[key].sceneHotspots.forEach((element: any) => {
    //                     console.log("DGB : marksMapData 2", element.weighting);
    //                 });
    //             }
    //         });
    //     }
    // }, [marksMapData]);

    return null;
}
